import {deleteCompany} from '../../api/companies'
import hydrateCompanies from './hydrateCompanies'

export default store => companyId => {
  const {token} = store.getState()

  store.setState({
    isHydratingCompanies: true,
  })

  if (!token) return

  return deleteCompany({
    token,
    companyId,
  })
    .then(res => {
      if (!res.ok) {
        throw res
      } else {
        return res.json()
      }
    })
    .then(response => {
      hydrateCompanies(store)()
    })
    .catch(error => {
      console.log({error})
      store.setState({
        isHydratingCompanies: false,
      })
    })
}
